"use strict";

export default {
    email: '',
    password: '',
    billingDetails: {
        f_name: '',
        l_name: '',
        company_name: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        zip5: '',
        zip4: '',
        phone: '',
        phone_ext: '',
        location_class: '',
    },
    currentStep: 0,
    editStep: null,
    isValid: {
        step1: false,
        step2: false,
        step3: false,
    },
    isFindingEmail: false,
    isCreatingAccount: false,
    isAccountCreated: false,
};
